import { CreerModule } from './../creer/creer.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/modules/shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PreferencesRoutingModule } from './preferences-routing.module';
import { PreferencesListeDiffusionComponent } from './preferences-liste-diffusion/preferences-liste-diffusion.component';
import { PreferencesListeCpvComponent } from './preferences-liste-cpv/preferences-liste-cpv.component';
import { PreferencesLogoComponent } from './preferences-logo/preferences-logo.component';
import { PreferencesListeFacturationComponent } from './preferences-liste-facturation/preferences-liste-facturation.component';
import { PreferencesAvisDePubComponent } from './preferences-avis-de-pub.component';
import { MatIconModule } from '@angular/material/icon';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { PreferencesCompteAnnonceurComponent } from './preferences-compte-annonceur/preferences-compte-annonceur.component';
import { PreferenceCpvDetailComponent } from './preferences-liste-cpv/preference-cpv-detail/preference-cpv-detail.component';
import { PartagePreferenceComponent } from './partage-preference/partage-preference.component';
import { ModalPartageComponent } from './modals/modal-partage/modal-partage.component';
import { PreferenceDiffuseurDetailComponent } from './preferences-liste-diffusion/preference-diffuseur-detail/preference-diffuseur-detail.component';
import { ModalDiffuseurComponent } from './modals/modal-diffuseur/modal-diffuseur.component';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { InterceptorService } from '../../../authentication/interceptor.service';
import { PreferencesAcheteurPrincipalComponent } from './preferences-acheteur-principal/preferences-acheteur-principal.component';
import { PreferenceAcheteurPrincipalDetailComponent } from './preferences-acheteur-principal/preference-acheteur-principal-detail/preference-acheteur-principal-detail.component';


@NgModule({
  declarations: [
		PreferencesAvisDePubComponent,
		PreferencesListeDiffusionComponent,
		PreferencesListeCpvComponent,
		PreferencesLogoComponent,
		PreferencesListeFacturationComponent,
		PreferencesCompteAnnonceurComponent,
		PreferenceCpvDetailComponent,
		PartagePreferenceComponent,
		ModalPartageComponent,
		PreferenceDiffuseurDetailComponent,
		ModalDiffuseurComponent,
    PreferencesAcheteurPrincipalComponent,
    PreferenceAcheteurPrincipalDetailComponent,
  ],
  imports: [
    CommonModule,
    PreferencesRoutingModule,
    TranslateModule,
    MatIconModule,
    SharedModule,
    FormsModule,
    NgbModule,
    ReactiveFormsModule,
    CreerModule,
  ],
	providers: [
		{ provide: HTTP_INTERCEPTORS, useClass: InterceptorService, multi: true }
	]
})
export class PreferencesModule { }
